<div class="grid-12col input-grid-gaps mb-4">
    @if (serviceId && form.controls.id?.value) {
        <div> {{ 'service.serviceBasicInfoForm.logo' | translate }}:</div>
        <app-input-logo
            class="fr-3"
            [owner]="'service_basic_info_'+form.controls.id.value"
            [imageUrl]="form.controls.image.value"
            (uploaded)="onFileUpload($event)"
        ></app-input-logo>
    }

    @if (serviceId) {
        <app-date-input
            id="validFrom"
            [form]="form"
            class="fr-2 align-self-end"
            label="service.serviceBasicInfoForm.validFrom"
        ></app-date-input>
    }

    @if (!serviceId) {
        <app-service-type-select
            [form]="form"
            class="fr-3"
            (collectionSelected)="serviceType.set($event)"
        ></app-service-type-select>
    }

    <div [ngClass]="{ 'fr-3': serviceId, 'fr-9': !serviceId }"></div>

    <app-text-input
        id="name"
        [form]="form"
        class="fr-4"
        label="service.serviceBasicInfoForm.name"
    ></app-text-input>
    <app-select-input
        id="regionId"
        [form]="form"
        class="fr-3"
        label="service.serviceBasicInfoForm.region"
        [staticOptions]="store.regions$ | async"
        [valueKey]="'id'"
        [filterBy]="'name,abbreviation'">
    </app-select-input>

    @if (featureOn.SERVICE_CENTER_MANAGER && store2.centerOptions().length) {
        <app-select-input
            id="centerId"
            [form]="form"
            class="fr-3"
            label="service.serviceBasicInfoForm.center"
            [staticOptions]="store2.centerOptions()"
            valueKey="id"
            labelKey="name"
            dataKey="id"
            [showClear]="true"
        ></app-select-input>
    }

    @if (isHealthCare()) {
        <app-select-input
            id="territorialVzpWorkplaceCode"
            [form]="form"
            class="fr-3"
            label="service.serviceBasicInfoForm.territorialVzpWorkplace"
            [staticOptions]="store.territorialVzpWorkplaces$ | async"
            [valueKey]="'code'"
            [filterBy]="'code,name'">
            <ng-template #item let-data>
                {{ data.code }} - {{ data.name }}
            </ng-template>
            <ng-template #selectedItem let-data>
                {{ data.code }} - {{ data.name }}
            </ng-template>
        </app-select-input>
    }
    @if (isSocial()) {
        <app-multi-select-input
            id="regionReportingIds"
            [form]="form"
            class="fr-3"
            [staticOptions]="store.regions$ | async"
            valueKey="id"
            label="service.serviceBasicInfoForm.regionReporting"
            filterBy="name,abbreviation"
        ></app-multi-select-input>
    }

    <app-multi-select-input
        id="form"
        [form]="form"
        class="fr-2"
        [staticOptions]="formOptions()"
        valueKey="value"
        label="service.serviceBasicInfoForm.form"
        display="comma"
    ></app-multi-select-input>

    <app-date-input
        id="registeredFrom"
        [form]="form"
        class="fr-2"
        label="service.serviceBasicInfoForm.registeredFrom"
    ></app-date-input>
    <app-date-input
        id="registeredTo"
        [form]="form"
        class="fr-2"
        label="service.serviceBasicInfoForm.registeredTo"
    ></app-date-input>
    <app-text-input
        id="ic"
        [form]="form"
        class="fr-3"
        label="service.serviceBasicInfoForm.ic"
    ></app-text-input>
    @if (isHealthCare()) {
        <app-text-input
            id="icz"
            [form]="form"
            class="fr-3"
            label="service.serviceBasicInfoForm.icz"
        ></app-text-input>
    }
    @if (isSocial()) {
        <app-text-input
            id="identifier"
            [form]="form"
            class="fr-3"
            label="service.serviceBasicInfoForm.identifier"
        ></app-text-input>
    }

    @if (isSocial()) {
        <app-multi-select-input
            id="regionScopeIds"
            [form]="form"
            class="fr-2"
            [staticOptions]="store.regions$ | async"
            valueKey="id"
            label="service.serviceBasicInfoForm.regionScope"
            filterBy="name,abbreviation"
        ></app-multi-select-input>
    }

    <app-address-input
        label="service.serviceBasicInfoForm.address"
        [form]="form"
        class="fr-4"
    ></app-address-input>
    <app-phone-input
        [form]="form"
        class="fr-3"
        label="service.serviceBasicInfoForm.phone"
    ></app-phone-input>
    <app-email-input
        [form]="form"
        class="fr-3"
        label="service.serviceBasicInfoForm.email"
    ></app-email-input>

    @if (isSocial()) {
        <app-check-input
            id="sharePersons"
            [form]="form"
            class="fr-2"
            label="service.serviceBasicInfoForm.sharePersons"
        ></app-check-input>
    }

    <app-select-user
        label="service.serviceBasicInfoForm.user"
        [form]="form"
        class="fr-4"
    ></app-select-user>

    <app-date-input
        id="systemFrom"
        [form]="form"
        class="fr-4"
        label="service.serviceBasicInfoForm.systemFrom"
        [disabled]="!store2.isAllowedGlobal('organization.update')()"
    ></app-date-input>
    <app-date-input
        id="systemTo"
        [form]="form"
        class="fr-4"
        label="service.serviceBasicInfoForm.systemTo"
        [disabled]="!store2.isAllowedGlobal('organization.update')()"
    ></app-date-input>

    <div class="fr-2">{{ 'service.serviceBasicInfoForm.bankAccountInfo' | translate }}:</div>
    <app-text-input
        id="bankAccountNumberPrefix"
        [form]="form"
        class="fr-2"
        label="service.serviceBasicInfoForm.bankAccountNumberPrefix"
    ></app-text-input>
    <app-text-input
        id="bankAccountNumber"
        [form]="form"
        class="fr-3"
        label="service.serviceBasicInfoForm.bankAccountNumber"
    ></app-text-input>
    <app-select-input
        id="bankCode"
        [form]="form"
        class="fr-2"
        label="service.serviceBasicInfoForm.bankCode"
        [staticOptions]="store.bankCodes$ | async"
        [valueKey]="'code'"
        [labelKey]="'code'"
        [filterBy]="'code'">
    </app-select-input>
    <app-text-input
        id="variableSymbol"
        [form]="form"
        class="fr-3"
        label="service.serviceBasicInfoForm.variableSymbol"
    ></app-text-input>
</div>

@if (serviceId) {
    <div class="dialogButtons">
        @if (form.dirty) {
            <app-save-button
                severity="secondary"
                label="service.serviceBasicInfoForm.updateInfo"
                (clickEvent)="updateEvent.emit()"
            ></app-save-button>
        }
        <app-button
            label="service.serviceBasicInfoForm.createNewInfo"
            icon="pi-plus"
            (clickEvent)="createEvent.emit()"
        ></app-button>
    </div>

    <p-divider></p-divider>
}
